<template>
  <div
    class="org-admin-deals-cont-types_odt org-admin-input_oai"
    v-if="contractTypesList"
    :class="{ [curTheme]: true }">
    <div class="oaf_label">Тип контракта</div>
    <el-select
      v-model="contractTypesLoc"
      multiple
      clearable
      @change="onChange"
      placeholder="Выберите тип контракта...">
      <el-option
        v-for="(type, i) in contractTypesList"
        :key="`opt-${i}`"
        :label="type.ContractTitle"
        :value="type.ContractId">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import axios from 'axios';

export default {

  props: ['contractTypes'],

  data() {
    return {
      contractTypesLoc: this.contractTypes,
      contractTypesList: [],
    };
  },

  created() {
    axios.get('deals/contractTypes').then((r) => {
      this.contractTypesList = r.data;
    }).catch(() => this.$notify.error(
      'Ошибка при загрузке типов операций над объектами.'));
  },

  watch: {
    contractTypes() {
      this.contractTypesLoc = this.contractTypes;
    },
  },

  methods: {
    onChange() {
      this.$emit('update:contractTypes', this.contractTypesLoc);
    },
  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.org-admin-obj-types_oap {
}
</style>



// WEBPACK FOOTER //
// src/components/org-admin/inputs/OrgAdminDealsContTypes.vue